"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDependency = exports.createIocContainerBuilder = void 0;
function createIocContainerBuilder(parent) {
    const dependencies = new Map();
    function resolve(id) {
        let value = dependencies.get(id);
        if (value === undefined && parent !== undefined) {
            value = parent.resolve(id);
        }
        if (value === undefined) {
            throw new Error(`dependency id: ${id.toString()} couldn't be resolved.`);
        }
        return value;
    }
    return {
        inject(id, value) {
            dependencies.set(id, value);
        },
        build() {
            return { resolve };
        },
        resolve
    };
}
exports.createIocContainerBuilder = createIocContainerBuilder;
function createDependency(id) {
    return {
        inject(builder, value) {
            builder.inject(id, value);
        },
        from(container) {
            return container.resolve(id);
        }
    };
}
exports.createDependency = createDependency;
//# sourceMappingURL=ioc-container.js.map